import { AiFillHeart, AiOutlineHeart } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { sendFavoriteCartData } from "../../store/cart-actions";
import { cartActions } from "../../store/cart-slice";
import { uiActions } from "../../store/Ui-slice";

const LikeAndUnLikeButton = (props: any) => {
  const dispatch = useDispatch();

  const Token = useSelector((state: any) => state.auth.token);
  const LoggedIn = useSelector((state: any) => state.auth.isLoggedIn);
  const favoriteCartData = useSelector(
    (state: any) => state.cart.favoriteItems.items
  );
  const existInFavoriteItem = favoriteCartData.find(
    (item: any) => item.id === props.item.id
  )
    ? true
    : false;
  const addToFavoriteHandler = () => {
    if (LoggedIn) {
      dispatch(cartActions.addOrRemoveFavoriteItemInList(props.item));
      dispatch(sendFavoriteCartData(props.item.id, Token));
      //console.log("addToFavoriteHandler:::", props.item.id, Token);
    } else {
      dispatch(uiActions.toggleModal());
    }
  };
  return (
    <div
      className="absolute left-2 top-2 p-2 cursor-pointer z-10 rounded-full bg-white/85 shadow-sm ring-1 ring-black/5 hover:bg-white transition"
      onClick={addToFavoriteHandler}
    >
      {existInFavoriteItem ? (
        <AiFillHeart className="text-rose-600 w-5 h-5" />
      ) : (
        <AiOutlineHeart className="text-rose-700 w-5 h-5" />
      )}
    </div>
  );
};

export default LikeAndUnLikeButton;
